<link href='/lib-legacy/style/zmax.min.css?t=20240229051639' rel="stylesheet" type="text/css" />
{@html `${ '<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js"></script>' }` }
{@html `${ '<script type="text/javascript" src="https://www.speedwaymotorsports.com/services/js/common-4.1.js"></script>' }` }
{@html `${ '<script type="text/javascript" src="https://www.speedwaymotorsports.com/services/js/bootstrap.min.js?t=20140324082839"></script>' }` }
{@html `${ '<script type="text/javascript" src="https://www.speedwaymotorsports.com/services/js/bootstrap-tabcollapse.min.js?t=20150113102001"></script>' }` }
{@html `${ '<script type="text/javascript" src="https://www.speedwaymotorsports.com/services/lib/fancybox/jquery.fancybox.min.js?t=20190401053021"></script>' }` }
{@html `${ '<script type="text/javascript" src="https://www.speedwaymotorsports.com/services/js/wow/wow.min.js"></script>' }` }
{@html `${ '<script type="text/javascript" src="https://www.speedwaymotorsports.com/js/zmax.min.js?t=20220511074628"></script>' }` }
{@html `${ '<script type="text/javascript" src="//use.typekit.net/zjd1fuz.js"></script>' }` }
{@html `${ '<script type="text/javascript">try { Typekit.load(); } catch ( e ) { }</script>' }` }

<style>

	:global( h1, h2, h3 )
	{
		text-transform: uppercase;
	}

	/* Breask card title in specials and events */
	/* :global( * h2 )
	{
		margin-top: 42px !important;
	} */

	:global( a, a:hover, a:focus, a:focus-within, a:active, a:visited )
	{
		text-decoration: none !important;
	}

	:global( .panel-title > a )
	{
		color: inherit !important;
	}

	:global( .panel-title > a:hover )
	{
		color: #d71920 !important;
	}

	
	:global( html body [data-id=HuqGJq-main-menu] a ),
	:global( html body [data-id=HuqGJq-main-menu] button[data-id=eyCT2h] ),
	:global( html body [data-id=HuqGJq-main-menu] [data-id=HuqGJq-main-sub-menu] a )
	{
		text-transform:uppercase;
		color: var(--clr-black-static);
		transition: none;
	}

	:global( html body [data-id=HuqGJq-main-menu] a ),
	:global( html body [data-id=HuqGJq-main-menu] button[data-id=eyCT2h] )
	{
		text-align: center;
		font-family: "Gilroy-Black", sans-serif;
		cursor: pointer;
	}

	:global( html body [data-id=HuqGJq-main-menu] a ),
	:global( html body [data-id=HuqGJq-main-menu] [data-id=HuqGJq-main-sub-menu] a )
	{
		font-family: "Gilroy-Medium", sans-serif !important;
		cursor: pointer;
	}

	:global( html body [data-id=HuqGJq-main-menu] a:hover button[data-id=eyCT2h] ),
	:global( html body [data-id=HuqGJq-main-menu] [data-id=HuqGJq-main-sub-menu] a:hover )
	{
		text-transform:uppercase;
		color: var(--clr-red-static);
		transition: none;
	}
	
	@media (max-width: 1535px)
	{
		:global( html body [data-id=HuqGJq-toggle] button[data-id=eyCT2h] ) 
		{
			border: none;
			background-color: transparent;
			margin-bottom: 0px !important;
		}

		:global( html body [data-id=HuqGJq-main-menu] a ),
		:global( html body [data-id=HuqGJq-main-menu] [data-id=HuqGJq-main-sub-menu] a )
		{
			text-align: center;
		}
		
		:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h] ) {
			border: none;
			padding-left: 0;
			padding-right: 16px;
		}

		:global( [data-id=HuqGJq-main-shopify] li:nth-child(1) button[data-id=eyCT2h] ) {
			background-color: transparent;
		}
		:global( [data-id=HuqGJq-main-shopify] li:nth-child(2) button[data-id=eyCT2h] ) {
			background-color: transparent;
		}
	}

	@media (min-width: 1536px)
	{

		:global( html body [data-id=HuqGJq-main-menu] a ),
		:global( html body [data-id=HuqGJq-main-menu] [data-id=HuqGJq-main-sub-menu] a )
		{
			text-align: left;
		}

		:global( [data-id=HuqGJq-main-shopify] li:nth-child(1) button[data-id=eyCT2h] ),
		:global( [data-id=HuqGJq-main-shopify] li:nth-child(1) button[data-id=eyCT2h]:hover ) {
			color: var(--clr-white-static);
			background-color: var(--clr-black-static);
		}
		:global( [data-id=HuqGJq-main-shopify] li:nth-child(2) button[data-id=eyCT2h] ),
		:global( [data-id=HuqGJq-main-shopify] li:nth-child(2) button[data-id=eyCT2h]:hover )  {
			color: var(--clr-black-static);
			background-color: var(--clr-gray-dark-static);
		}
	}

	
	:global( [data-id=HuqGJq-main-menu] button[data-id=eyCT2h]:focus ), 
	:global( [data-id=HuqGJq-main-menu] button[data-id=eyCT2h]:active ) {
		background-color: transparent !important;
	}

	:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h] ),
	:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h] * )  {
		text-transform: uppercase;
		text-align: center;
		font-family: "Titillium Web", sans-serif !important;
		font-size: 14px;
		font-weight: 600 !important;
		cursor: pointer;
		border: none !important;
	}

	:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h]:nth-of-type(1) )
	:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h]:nth-of-type(1):hover )
	{
		background-color: var(--clr-black-static);
	}

	:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h]:nth-of-type(2) ),
	:global( [data-id=HuqGJq-main-shopify] button[data-id=eyCT2h]:nth-of-type(2):hover )
	{
		color: var(--clr-black-static) !important;
		background-color: var(--clr-gray-dark-static);
		border: 10px solid red;
	}

	:global( html body [data-id=DsCZvR_social] li) 
	{
		flex: initial;
	}
</style>